/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zipping_Inputs */

const en_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zipping... (`)
};

const es_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimiendo... (`)
};

const fr_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compression... (`)
};

const de_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gezippt... (`)
};

const ja_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮中... (`)
};

const zh_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在压缩... (`)
};

const ar_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري الضغط... (`)
};

const id_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengompresi... (`)
};

const it_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compressione in corso... (`)
};

const ru_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архивация... (`)
};

const pt_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comprimir... (`)
};

const ko_zipping_ = /** @type {(inputs: Zipping_Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축 중... (`)
};

/**
* | output |
* | --- |
* | "Zipping... (" |
*
* @param {Zipping_Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const zipping_ = /** @type {((inputs?: Zipping_Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zipping_Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zipping_(inputs)
	if (locale === "es") return es_zipping_(inputs)
	if (locale === "fr") return fr_zipping_(inputs)
	if (locale === "de") return de_zipping_(inputs)
	if (locale === "ja") return ja_zipping_(inputs)
	if (locale === "zh") return zh_zipping_(inputs)
	if (locale === "ar") return ar_zipping_(inputs)
	if (locale === "id") return id_zipping_(inputs)
	if (locale === "it") return it_zipping_(inputs)
	if (locale === "ru") return ru_zipping_(inputs)
	if (locale === "pt") return pt_zipping_(inputs)
	return ko_zipping_(inputs)
});